export const SIGNUP_JOTFORM_URLS = {
  FULL_REGISTRATION_FORM: 'https://forms.expressable.com/251055433478963',
  INSURANCE_CARD: 'https://forms.expressable.com/250986857903978',
} as const;

export enum JotformRedirectReason {
  AVAILABILITY_BAILOUT = 'availability_bailout',
  ELIGIBILITY_BAILOUT = 'eligibility_bailout',
  AVAILABILITY_AUTOMATIC_BAILOUT = 'availability_automatic_bailout',
  INSURANCE_NOT_SUPPORTED_AUTOMATIC_BAILOUT = 'insurance_not_supported_automatic_bailout',
  NO_PCP_BAILOUT = 'no_pcp_bailout',
  NEEDS_DIFFERENT_AVAILABILITY = 'needs_different_availability',
  HAS_QUESTION = 'has_question',
}

export type JotformRedirectVariant = keyof typeof SIGNUP_JOTFORM_URLS;

export const JOTFORM_REASON_URL_MAP: Record<JotformRedirectReason, JotformRedirectVariant> = {
  [JotformRedirectReason.AVAILABILITY_BAILOUT]: 'FULL_REGISTRATION_FORM',
  [JotformRedirectReason.ELIGIBILITY_BAILOUT]: 'INSURANCE_CARD',
  [JotformRedirectReason.AVAILABILITY_AUTOMATIC_BAILOUT]: 'FULL_REGISTRATION_FORM',
  [JotformRedirectReason.INSURANCE_NOT_SUPPORTED_AUTOMATIC_BAILOUT]: 'FULL_REGISTRATION_FORM',
  [JotformRedirectReason.NO_PCP_BAILOUT]: 'FULL_REGISTRATION_FORM',
  [JotformRedirectReason.NEEDS_DIFFERENT_AVAILABILITY]: 'FULL_REGISTRATION_FORM',
  [JotformRedirectReason.HAS_QUESTION]: 'FULL_REGISTRATION_FORM',
};
